import { render, staticRenderFns } from "./wechatTest.vue?vue&type=template&id=0a72c866&"
import script from "./wechatTest.vue?vue&type=script&lang=js&"
export * from "./wechatTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports